import { createGlobalStyle } from 'styled-components';
import { normalize } from 'styled-normalize';
import UtilsVisibilityCss from './UtilsVisibility';
const NdsGlobalStyle = createGlobalStyle `

  ${normalize}

  body {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-rendering: optimizeLegibility;
    box-sizing: border-box;
  }

  *, *::before, *::after {
    box-sizing: inherit;
  }

  /* tooltip */
  ._ndsTooltip__reference {
    z-index: ${(props) => props.theme.zIndex.topLayer};
  }

  ${UtilsVisibilityCss}


`;
export default NdsGlobalStyle;
//# sourceMappingURL=NdsGlobalStyle.js.map